(() => {
  'use strict';

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link) return;

    const destination = new URL(link.href, window.location.href);
    if (destination.origin !== window.location.origin || !destination.pathname.endsWith('/pages/bfs-setup-builder')) return;

    const collectionEntry = link.dataset.bfsEntrySource === 'bfs_collection';
    const navigationEntry = link.textContent.trim() === 'Build Your BFS Setup' &&
      link.closest('.discovery-navigation, .header, .nav-bar, #mobile-menu, [data-section-type="header"]');
    const source = collectionEntry ? 'bfs_collection' : navigationEntry ? 'fishing_navigation' : null;
    if (!source) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'builder_entry', entry_source: source, destination: destination.pathname });
  }, true);
})();
